import React from "react";
import "./privacypolicy.scss";
const PrivacyPolicy = () => {
    return (
        <div className="privacy-policy">
            <h1>Privacy Policy for Goldwrench Automotive</h1>
            <p>Last Updated: 01/22/2024</p>

            <section>
                <h2>Introduction</h2>
                <p>Welcome to the Goldwrench Automotive website. This Privacy Policy outlines our policies regarding the collection, use, and disclosure of personal information we receive from users of our site. By accessing and using our website, you agree to the collection and use of information in accordance with this policy. Unless otherwise defined, terms used in this Privacy Policy have the same meanings as in our Terms and Conditions.</p>
            </section>

            <section>
                <h2>Information Collection and Use</h2>
                <p>While using our site, we may ask you to provide us with certain personally identifiable information that can be used to contact or identify you. Personally identifiable information may include, but is not limited to, your name, email address, and phone number ("Personal Information").</p>
            </section>

            <section>
                <h2>Log Data</h2>
                <p>Like many site operators, we collect information that your browser sends whenever you visit our site ("Log Data"). This Log Data may include information such as your computer's Internet Protocol ("IP") address, browser type, browser version, the pages of our site that you visit, the time and date of your visit, the time spent on those pages, and other statistics.</p>
            </section>

            <section>
                <h2>Cookies</h2>
                <p>Cookies are files with small amounts of data, which may include an anonymous unique identifier. Cookies are sent to your browser from a web site and stored on your computer's hard drive. Like many sites, we use cookies to collect information. You can instruct your browser to refuse all cookies or to indicate when a cookie is being sent. However, if you do not accept cookies, you may not be able to use some portions of our site.</p>
            </section>

            <section>
                <h2>Security</h2>
                <p>The security of your Personal Information is important to us, but remember that no method of transmission over the Internet, or method of electronic storage, is 100% secure. While we strive to use commercially acceptable means to protect your Personal Information, we cannot guarantee its absolute security.</p>
            </section>
            <section>
                <h2>Coppa</h2>
                <p>
                    We do not knowingly collect personally identifiable information from children under 13. If you are a parent or guardian and are aware that your children have provided us with Personal Information, please contact us. If we discover that a child under 13 has provided us with Personal Information, we will delete such information from our servers as soon as possible.
                </p>
            </section>


            <section>
                <h2>Changes to This Privacy Policy</h2>
                <p>This Privacy Policy is effective as of 01/22/2024 and will remain in effect except with respect to any changes in its provisions in the future, which will be in effect immediately after being posted on this page. We reserve the right to update or change our Privacy Policy at any time and you should check this Privacy Policy periodically. Your continued use of the service after we post any modifications to the Privacy Policy on this page will constitute your acknowledgment of the modifications and your consent to abide and be bound by the modified Privacy Policy.</p>
            </section>

            <section>
                <h2>Contact Us</h2>
                <p>If you have any questions about this Privacy Policy, please contact us through phone (540) 949-6835.</p>
            </section>
        </div>
    );
};

export default PrivacyPolicy;
